module.exports = __webpack_public_path__ + "assets/imgs/achs/fb.ba6a84ec231354ec5288d6a0d45522ad.png";